//1.引入vue
import Vue from 'vue'
//2.引入 vue-router
import VueRouter from 'vue-router'
//3.实例化路由
Vue.use(VueRouter)

const whiteList = ['/login', '/reset_passwords', '/yszc', '/register'] // 允许未登录用户访问的页面

// 4. 定义路由组件

//5.定义路由
const router = new VueRouter({
  mode: 'hash', // 1.history路由  2.hash路由    // history路由 后面无#   hash路由后面有#
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('../view/BackGround.vue')
      // redirect: '../view/BackGround.vue' //设置路由重定向
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../view/LoGin.vue') //路由懒加载
      //懒加载优点：在页面跳转的时候进行加载，提升了页面的流畅性
    },
    {
      path: '/reset_passwords',
      name: 'reset_passwords',
      component: () => import('../components/resetPassword.vue') //路由懒加载
      //懒加载优点：在页面跳转的时候进行加载，提升了页面的流畅性
    },
    {
      path: '/yszc',
      name: 'yszc',
      component: () => import('../view/yszc.vue') //路由懒加载
      //懒加载优点：在页面跳转的时候进行加载，提升了页面的流畅性
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('../components/register.vue') //路由懒加载
      //懒加载优点：在页面跳转的时候进行加载，提升了页面的流畅性
    },
    {
      path: '/background',
      name: 'background',
      component: () => import('../view/BackGround.vue')
    },
    {
      path: '/access_forbidden',
      name: 'background',
      component: () => import('../view/access_forbidden.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('token')

  // 检查用户是否有 token
  if (token) {
    // 如果已经有 token 且访问的是登录页，重定向到主页
    if (to.path === '/login') {
      next({ path: '/' }) // 跳转到主页
    } else {
      next() // 继续访问目标路由
    }
  } else {
    // 如果没有 token，检查目标路由是否在白名单中
    if (whiteList.includes(to.path)) {
      next() // 允许访问白名单中的路由
    } else {
      next({ path: '/login' }) // 跳转到登录页
    }
  }
})

export default router //将路由导出
